import handleQueryError from '../../../util/Common/Error/Handler/handleQueryError';
import commonDefaultAPI from '../api';

const getSSLList = async ({ keyword }) => {
  try {
    const response = await commonDefaultAPI.get(
      `ssl-list${keyword ? `/${keyword}` : ''}`,
    );
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getSSLList;
